// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/* eslint-disable @typescript-eslint/naming-convention */
import packageJson from '../../package.json';
export const LIBRARY_VERSION = packageJson.version;
export const COOKIE_NAME_PREFIX = 'sc_';
export const DEFAULT_COOKIE_EXPIRY_DAYS = 730;
export const DAILY_SECONDS = 86400;
export const API_VERSION = 'v1.2';
export const SITECORE_EDGE_URL = 'https://edge-platform.sitecorecloud.io';
